import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Error de interfaz:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4" data-testid="error-boundary">
        <div className="max-w-md rounded-xl border border-border bg-card p-6 text-center shadow-sm">
          <h1 className="text-xl font-semibold text-foreground">No se pudo mostrar esta página</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Ocurrió un error inesperado al cargar la interfaz. Recargue la página para reintentar.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
            data-testid="error-boundary-reload-btn"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }
}
